import "./DocumentCard.scss";

import React from "react";

import DownloadIcon from "@mui/icons-material/Download";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from "@mui/material";

import { DocumentCardData } from "../../models/app-data-model";

export type DocumentCardProps = {
  DocumentCardData: DocumentCardData;
};

const DocumentCard: React.FC<DocumentCardProps> = ({ DocumentCardData }) => {
  const title = DocumentCardData.title;
  const short_description = DocumentCardData.short_description;
  const button_label = DocumentCardData.button_label;
  const button_url = DocumentCardData.button_url;
  
  return (
    <Card className="card">
      <CardContent className="card-content">
        <Typography variant="h4" className="content-title">
          {title}
        </Typography>
        {short_description && <div className="content-category-date">
            {short_description}
          </div>}
      </CardContent>
      <CardActions disableSpacing className="card-actions">
        <Button size="large" variant="contained" className="action-button" startIcon={<DownloadIcon />} title={title} target='_blank' href={button_url}>{button_label}</Button>
      </CardActions>
    </Card>
  );
};

export default DocumentCard;

